<p-panel>
    @if (!formReady) {
        <div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
            <p-progressSpinner
                strokeWidth="4"
                [style]="{width: '60px', height: '60px'}"
                animationDuration=".8s">
            </p-progressSpinner>
        </div>
    }

    @if (formReady) {
        <app-reactive-form-builder
            (formChanges)="formChanges($event[0], $event[1])"
            (goBack)="goBack()"
            [form]="form.formFields"
            [dropdownLoadTrigger]="dropdownLoadTrigger"
            [id]="(getModel().id ?? '') + ''"
            [request]="this.getType() === 1 ? this.tareasApi.siembra.PUT : this.tareasApi.siembra.POST"
            [getRequest]="tareasApi.siembra.GET">
        </app-reactive-form-builder>
    }
</p-panel>
